import { useLocation, Outlet } from "react-router-dom";
import {
  LayoutDashboard, CalendarRange, FileText, ClipboardCheck,
  BarChart3, Settings, Umbrella,
} from "lucide-react";
import HubSidebar from "@/components/HubSidebar";


import TopNav from "@/components/TopNav"
import HubSwitcher from "@/components/HubSwitcher";
const NAV_ITEMS = [
  {
    id: "dashboard",
    label: "Dashboard",
    icon: LayoutDashboard,
    path: "/hr-hub/leave-management/dashboard",
    description: "Balances & overview",
  },
  {
    id: "request",
    label: "Apply for Leave",
    icon: FileText,
    path: "/hr-hub/leave-management/request",
    description: "New leave application",
  },
  {
    id: "my-leave",
    label: "My Leave",
    icon: Umbrella,
    path: "/hr-hub/leave-management/my-leave",
    description: "My applications",
  },
  {
    id: "approvals",
    label: "Approvals",
    icon: ClipboardCheck,
    path: "/hr-hub/leave-management/approvals",
    description: "Pending approvals",
  },
  {
    id: "calendar",
    label: "Calendar",
    icon: CalendarRange,
    path: "/hr-hub/leave-management/calendar",
    description: "Leave planner",
  },
  {
    id: "capacity",
    label: "Capacity",
    icon: BarChart3,
    path: "/hr-hub/leave-management/capacity",
    description: "Team capacity board",
  },
  {
    id: "admin",
    label: "Settings",
    icon: Settings,
    path: "/hr-hub/leave-management/admin",
    description: "Leave admin console",
  },
];

export default function LeaveManagementLayout() {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <>
    <TopNav />
    <div className="flex min-h-screen bg-app flex-col md:flex-row">
      <HubSidebar
        navItems={NAV_ITEMS}
        title="LEAVE MGMT"
        subtitle="HR Hub Module"
        icon={Umbrella}
        gradient="from-emerald-500 to-teal-600"
        activeBg="bg-emerald-500"
        backLink="/hr-hub"
        backLabel="Back to HR Hub"
        sidebarWidth="w-64"
      />

      <main className="flex-1 overflow-auto flex">
        <div className="flex-1 min-w-0 p-4">
          <Outlet />
        </div>
        <div className="hidden lg:block w-40 shrink-0 p-3 border-l border-app">
          <HubSwitcher />
        </div>
      </main>
    </div>
    </>
  );
}
